<template>
    <div>
        <div class="d-flex" id="container">
            <span class="p-2 mt-1">
                <i class="fa fa-plus cursor-pointer"
                    @click="showDetails"
                    v-if="!details">
                </i>
                <i class="fa fa-minus cursor-pointer"
                    @click="showDetails"
                    v-if="details">
                </i>
            </span>

            <div class="card">
                <div class="card-header m-0">
                    <div class="d-flex justify-content-between" id="contact-details">
                        <span class="item" >
                            <input class="mr-1"
                                v-model="selectedContact"
                                type="checkbox"
                                :id="'contact-' + contact.id"
                                @change="select(contact.id)"
                                :value="contact.id" />
                            <span class="text-primary cursor-pointer mr-2"
                                @click.prevent="openModal(contact)">
                                <i class="fab fa-facebook" v-if="contact.source === 'facebook'"></i>
                                {{ name | maxSizeString(19) }}
                            </span>
                        </span>

                        <span class="item">
                            <i class="fa fa-phone mr-1"></i>
                            <span v-if="phoneNumber">
                                {{ phoneNumber | maxSizeString }}
                            </span>
                            <span v-if="!phoneNumber">
                                <em class="text-muted mr-2">No phone number</em>
                            </span>
                        </span>

                        <span class="item" >
                            <i class="fa fa-envelope mr-1"></i>
                            <span v-if="email">{{ email | maxSizeString }}</span>
                            <span v-if="!email">
                                <em class="text-muted">No email</em>
                            </span>
                        </span>

                        <span class="item">
                            <i class="fa fa-location-arrow"></i>
                            <span v-if="getInvitesLocations">
                                {{ getInvitesLocations | maxSizeString(19) }}
                            </span>
                            <span v-if="!getInvitesLocations">
                                <em class="text-muted">No location</em>
                            </span>
                        </span>

                        <span style="flex: 0.45; color: #B2B2B2;">
                            <i style="padding-right: 5px;" class="fas fa-user"/>
                            {{ contact.id }}
                        </span>

                        <span class="ml-3" v-if="!locationUser">
                            <div class="dropdown-toggle btn btn-default btn-icon btn-sm" style="background-color: inherit;" data-toggle="dropdown">
                                <i class="fa fa-ellipsis-h"></i>
                            </div>
                            <div class="dropdown-menu dropdown-menu-right">
                                <a class="dropdown-item" href="#" @click="openModal(contact)">
                                    Edit
                                </a>
                                <a class="dropdown-item" href="#" @click="blockContact(contact)" v-if="showBlock">
                                    Block
                                </a>
                                <a class="dropdown-item" href="#" @click="unblockContact(contact)" v-if="showUnblock">
                                    Unblock
                                </a>
                                <a class="dropdown-item" href="#" @click="remove(contact)">
                                    Delete
                                </a>
                            </div>
                        </span>
                    </div>
                </div>

                <transition name="fade-in-down">
                    <div class="card-body p-0" v-if="details">
                        <card-spinner
                            v-if="loading"
                            style="height: 50px;"
                            size="small"
                        />
                        <transition name="fade-in-down">
                            <span v-if="!loading">
                                <grid-content-row class="d-flex flex-column">
                                    <invitation-history
                                        :invites="invites"
                                        :timezone="timezone"
                                    />
                                </grid-content-row>
                                <grid-content-row>
                                    <tags
                                        v-model="contact.tags"
                                        :options="tags"
                                        @input="update(contact)"
                                    />
                                </grid-content-row>
                            </span>
                        </transition>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            contact         : {required: true},
            tags            : {required: true},
            selectedContacts: {required: true},
            locationUser    : {required: true},
            showBlock       : {required: false, default: false},
            showUnblock     : {required: false, default: false},
        },

        data: () => ({
            timezone    : null,
            loading     : false,
            details     : false,
            invites     : [],
            contact_tags: []
        }),

        filters: {
            maxSizeString(value, size = 15) {
                return value && value.length > size ? value.substring(0, size - 2) + '...' : value;
            }
        },
        created() {
            this.fetchTimezone();
        },
        computed: {
            selectedContact: {
                get() {
                    return this.selectedContacts;
                },
                set() {
                }
            },

            name() {
                return this.contact.name;
            },

            email() {
                return this.contact.email;
            },

            phoneNumber() {
                return this.contact.phone_number;
            },

            createdAt() {
                return this.contact.created_at;
            },

            getInvitesLocations() {
                var locations = [];
                for (var i = this.contact.locations.length - 1; i >= 0; i--) {
                    locations.push(this.contact.locations[i].name);
                }

                if(locations.length == 0 ){
                    return "no locations";
                }

                return locations.join();
            }
        },

        methods: {
            fetchTimezone()  {
                return this.$http.get(this.$laroute.route('api.teams.current-team-timezone')).then(({ data }) => {
                    this.timezone = data;
                });
            },
            select(id) {
                this.$emit('selected', id)
            },

            update(contact) {
                this.$emit('updated', contact);
            },

            remove(contact) {
                this.$emit('deleted', contact);
            },

            openModal(contact) {
                this.$emit('openModal', contact);
            },

            showDetails() {
                if (this.details) {
                    this.details = false;
                    this.invites = [];
                    return;
                }

                this.details = true;
                this.loading = true;
                this.$http.get(this.$laroute.route('contact-invites', {contact: this.contact.id}))
                    .then(({data}) => {
                        this.invites = data;
                        this.loading = false;
                    });
            },

            blockContact(contact) {
                this.$emit('block', contact);
            },

            unblockContact(contact) {
                this.$emit('unblock', contact);
            },
        }
    }
</script>


<style lang="scss" scoped>
    .d-flex {
        flex-wrap: wrap;
    }

    .item {
        flex: 1 1;
    }

    .card {
        border-radius: 0;
        flex-grow: 1;
    }

    #container {
        margin-bottom: -20px;
    }

    @media screen and (max-width: 991px) {
        #container {
            flex-direction: column;
            align-items: center;
        }
        .card {
            width: 100%;
        }
        #contact-details {
            flex-direction: column;
            text-align: center;
        }

        .item:not(:last-child) {
            margin-bottom: 10px;
        }

        .id {
            flex: 0.25;
            color: #B2B2B2;
        }
    }
</style>
